import React, { useContext } from 'react';
import { IoMdClose } from 'react-icons/io';
import moment from 'moment';

import { StartFarmContext } from '../../../context/startFarmContext';

const FarmDetails = ({ product }) => {
  const { handleDetailsModal, detailsModal } = useContext(StartFarmContext);
  return (
    <div className={detailsModal ? 'show' : 'hidden'}>
      <div className="modal-bg">
        <div className="relative flex flex-wrap justify-center items-center h-screen w-screen">
          <div className="fixed top-0 left-0 bg-cf-300 text-gray-200 rounded p-3 ml-80 mt-12">
            Farm Details
          </div>
          <div className="relative bg-white rounded p-16 w-125">
            <div
              onClick={handleDetailsModal}
              className="absolute right-0 top-0 mt-6 mr-6 text-2xl text-cf-dark font-bold cursor-pointer"
            >
              <IoMdClose />
            </div>
            <div className="flex flex-wrap text-sm text-gray-800">
              <div className="w-1/2 pr-4 mb-6">
                <div className="bg-cf-200 rounded p-3">
                  <h6 className="text-base">
                    {product.crop.name} - <span className="font-sans">Stage 1</span>
                  </h6>
                  <p className="text-xs">
                    Opening date - {moment(product.startDate).format('MMMM Do, YYYY')}
                  </p>
                  <p className="text-xs">Farm duration - {product.duration} Months</p>
                  <p className="text-xs">Farm size - {product.acerage} Acres</p>
                  <p className="text-xs">
                    Farm location - {product.location.name}, {product.location.state},{' '}
                    {product.location.country}
                  </p>
                  <p className="text-xs">
                    Return After Harvest - {product.projectedReturnsPerAcre}%
                  </p>
                  <p className="text-xs">Price per unit - ${product.pricePerAcre}</p>
                </div>
              </div>
              <div className="w-1/2 pl-4 mb-6">
                <div className="bg-cf-200 rounded p-3">
                  <h6 className="text-base">General Stage Description</h6>

                  <div>
                    <small>Here are the details</small>
                    <p className="text-xs">
                      <span className="font-bold">Farm Stage 1:</span> First stage - Planting and
                      Input
                    </p>
                    <p className="text-xs">
                      <span className="font-bold">Farm Stage 2:</span> Second stage - Core Farming
                      Activities (collection of tasks)
                    </p>
                    <p className="text-xs">
                      <span className="font-bold">Farm Stage 3:</span> Third stage - Post-harvest
                      and Storage
                    </p>
                  </div>
                </div>
              </div>
              <div className="w-1/2 pr-4">
                <div className="bg-cf-200 rounded p-3">
                  <h6 className="text-base">Catchment Area</h6>
                  <div>
                    {/* <p className="text-xs">
                      <span className="font-bold">Climatic conditions:</span>
                    </p> */}
                    <p className="text-xs">{product.location.description}</p>
                  </div>
                </div>
              </div>
              <div className="w-1/2 pl-4">
                <div className="bg-cf-200 rounded p-3">
                  <h6 className="text-base">Market Trends</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FarmDetails;
